import { createTheme } from '@material-ui/core/styles'

export const variables = {
  colors: {
    primary: '#045781',
    primaryBackground: '#DAF0FF',
    accent: '#F4FBFF',
    accentBackground: '#36A4EF',
    darkSurface: '#062337',
    zipYellow: '#CBB3FD',

    textDark: '#282828',
    textMedium: '#494949',
    textSubtle: '#757575',

    highVariability: '#CD9B93',
    someVariability: '#FFC8A3',
    littleVariability: '#FFE2A3',

    alabaster: '#f7f7f7',
    faintGray: '#EAEAEA',
    faintBorder: '#EAEAEA',
    pictonBlue: '#28a2ed',
    // muiButtonOutline: 'rgba(0, 0, 0, 0.12)',

    black: '#000000',
    white: '#ffffff',
    darkGray: '#03171C',
    // middleGray: '#494949',
    lightGray: '#616161',
    veryLightGray: '#d6d6d6',
    ungradedGray: '#aaa',
    ddkRed: '#C9422C',
    ddkMainBlue: '#0F7ABD', // "denim"
    ddkBlue: '#013457',
    lightBlue: 'rgba(201, 232, 248, 0.3)',
    ddkLightRedHex: 'rgba(248, 231, 229, 1)',
    ddkNavy: '#045781',
    ddkAnotherNavy: `#3B5998`,
    ddkAnotherGray: `#5E5E5E`,
    ddkAnotherOneOffBlue: `#1DA1F2`,
    ddkALighterOneOffBlue: `rgba(29,161,242,0.1)`,
    ddkYetAnotherAnotherLightGray: `#F2F2F2`,

    // lighterGray: '#D3D3D3',
    // lightLightGray: '#eee',
    // bridalHeath: '#fffbf3',
    // oldLace: '#fdf5e9',
    // magnolia: '#fbfaff',
    // greenWhite: '#ebede3',
    // alto: '#d7d7d7',
    // boulder: '#757575',
    // capeCod: '#3c4748',
    // codGray: '#181818',
    // dkGray: '#4b4b4b',
    // firefly: '#08131f',
    // towerGray: '#9dbab7',
    // flaxSmoke: '#818967',
    // chaletGreen: '#4a6f34',
    // turtleGreen: '#2c390b',
    // shark: '#292d33',
    // cinnabar: '#e94f34',
    // orangeRoughy: '#d4441c',
    // fog: '#d8ccff',
    // deluge: '#7768ae',
    // txtLogo: '#8f9287',
    // criColor1: '#7b53ef',
    // criColor3: '#cabbf5',
    // barHighlight: '#e94f34',
    // cpLabelColor: '#606b44',
    // ddkHighlightBlue: '#36A4EF', accentBackground
    // ddkLightRed: 'rgba(201, 66, 44, 0.1)',
  },
  dimensions: {
    navbarHeight: '64px',
    navbarHeightPx: 64,
    navbarHeightSmPx: 56,
    spacer: `0.8rem`,
  },
  breakpoints: [0, 320, 768, 992, 1280],
  fonts: {
    primary: 'Fira Sans',
  },
}

export const theme = createTheme({
  // Update theme here according to the Mui documentation
  palette: {
    text: {
      primary: variables.colors.textMedium,
      secondary: variables.colors.textSubtle,
    },
    primary: {
      main: variables.colors.ddkNavy, // '#6200EE',
      dark: 'purple',
    },
    secondary: {
      main: variables.colors.ddkMainBlue,
      // main: '#03DAC5', // "robin eggs blue"
      dark: 'green',
    },
    error: {
      main: '#B00020',
    },
  },
  typography: {
    fontFamily: 'Fira Sans',
    fontWeight: 400,
    color: variables.colors.textDark,
    lineHeight: 1.43,

    h1: {
      fontSize: '15px',
      color: variables.colors.textDark,
      fontWeight: 500,
      lineHeight: '18px',
    },
    h2: {
      fontSize: '14px',
      color: variables.colors.textDark,
      fontWeight: 500,
      lineHeight: '18px',
    },
    h3: {
      fontSize: '13px',
      color: variables.colors.textDark,
      fontWeight: 500,
      lineHeight: '18px',
    },
    // subtitle1: {},
    // subtitle2: {},
    // caption: {},

    body1: {
      // sm-label
      fontSize: '13px',
      color: variables.colors.textMedium,
      fontWeight: 400,
      lineHeight: '18.2px',
    },
    body2: {
      // xs-label
      fontSize: '12px',
      color: variables.colors.textMedium,
      fontWeight: 300,
      lineHeight: '16.9px',
    },
    caption: {
      // xxs-label
      fontSize: '10px',
      color: variables.colors.textMedium,
      fontWeight: 300,
      lineHeight: '12px',
    },
  },
  overrides: {
    MuiTooltip: {
      // Arrow styling.
      arrow: {
        color: variables.colors.black,
      },
      tooltip: {
        maxWidth: '295px',
      },
      // Tooltip body and contents.
      tooltipArrow: {
        backgroundColor: variables.colors.black,
        fontSize: '14px',
        padding: '16px',
        fontFamily: `'Fira Sans', helvetica, arial`,
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
      },
    },
    MuiToggleButton: {
      root: {
        textTransform: 'none',
      },
    },
    MuiButtonBase: {
      root: {
        '&:hover': {
          backgroundColor: variables.colors.accent,
        },
      },
    },
    MuiIconButton: {
      root: {
        '&:hover': {
          backgroundColor: variables.colors.accent,
        },
      },
    },
    MuiListItem: {
      button: {
        '&$selected, &$selected:hover': {
          backgroundColor: variables.colors.accent,
        },
        '&:hover': {
          backgroundColor: variables.colors.accent,
        },
      },
    },
  },
  extras: {
    Legend: {
      width: '252px',
      cushionRight: 15,
      cushionTop: 25,
      zIndex: 13,
      // height: 420,
      heightMobile: 255,
    },
    controlPanel: {
      width: 72,
      zIndex: 15,
    },
    slideoutPanel: {
      width: 366,
      zIndex: 14,
    },
    chart: {
      width: 380,
      zIndex: 14,
    },
    UserHints: {
      maxWidth: 340,
      zIndex: 1111, // above header (.MuiAppBar-root)
    },
    sharePopper: {
      width: 349,
      widthMobile: 329,
    },
    mapPopup: {
      width: 283,
      height: 220,
      edgePadding: 100,
      offset: 50,
    },
    introModal: {
      buttonWidth: 288,
    },
    autoSuggest: {
      width: 338,
    },
    variables: variables,
    ratings: {
      levelColors: [
        '#C3D7E3',
        '#7BAAC6',
        '#4B86AA',
        '#265674',
        '#032942',
      ],
      scoreColors: [
        '#E8EEF4',
        '#A7BACC',
        '#7596B5',
        '#4F7BA4',
        '#295E90',
        '#134879',
        '#0A3760',
        '#001D38',
      ],
    },
    variability: {
      backgroundFill: ['#F6EFB0', '#F1C886', '#F0846C'],
      iconFill: ['#7F751A', '#86642C', '#8B2B16'],
    },
    demos: {
      t: '#B3B3B3', // 'All' demo for the VariabilityChart
      w: '#84DCBE',
      hi: '#A289F8',
      b: '#F4CD6B',
      ap: '#E48970',
      ai: '#CA66AB',
    },
    redlining: {
      A: '#5FF191',
      B: '#33C3F0',
      C: '#FCE61E',
      D: '#FF5631',
    },
    styles: {
      faintBorder: `1px solid ${variables.colors.faintBorder}`,
    },
  },
})
